export const INVOICES_SECTION_KEY = 'invoicesSection'
